import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/campaigns/upload/cities", payload);
  },
};
